import history from '../router/history';
import * as utils from '../util/bellplus-utils';
import routes from '../constants/Routes';

export const logoutApp = () => {

	    utils.removeData('userDetails');
        history.push(routes.LOGIN.path);
        
}